import { useState } from 'react';

import { useSaveIndustry } from '@/api/queries';
import type { Industry } from '@/api/types';
import { Modal } from '@/ui/Modal';
import { FormError } from '@/ui/StateCard';
import { ActionButton, buttonState } from '@/ui/ActionButton';
import { industryDialogText } from './industryList';
import { industryInDescriptionOneMax, industryInNameMax } from '@/api/generated/schemas/industryIn.zod';

export function IndustryDialog({ industry, onClose }: { industry?: Industry; onClose: () => void }) {
  const save = useSaveIndustry();
  const [name, setName] = useState(industry?.name ?? '');
  const [description, setDescription] = useState(industry?.description ?? '');
  const text = industryDialogText(industry);

  return (
    <Modal
      title={text.title}
      subtitle={text.subtitle}
      size="narrow"
      onClose={onClose}
      onSubmit={() =>
        save.mutate(
          {
            id: industry?.id,
            change: {
              name: name.trim(),
              description: description.trim() || null,
            },
          },
          { onSuccess: onClose },
        )
      }
      footer={
        <>
          <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <ActionButton state={buttonState(save)} label={text.submitLabel} disabled={!name.trim()} />
        </>
      }
    >
      <div className="stack-md">
        <FormError error={save.error} />
        <div className="field">
          <label htmlFor="industry-name">Name</label>
          <input id="industry-name" type="text" required autoFocus maxLength={industryInNameMax} value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div className="field">
          <label htmlFor="industry-description">Description</label>
          <textarea
            id="industry-description"
            rows={3}
            maxLength={industryInDescriptionOneMax}
            value={description}
            placeholder="Optional: what belongs here"
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
      </div>
    </Modal>
  );
}
